module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-3.7a119d63.jpg";